import React, { memo } from "react";
import { Modal } from "@shopify/polaris";
import intl from "../../../../i18n/intl";

const ArchiveOrderModal = memo(
  ({ bulkSourceData ,setBulkSourceData}) => {
    return (
      <div>
        <Modal
          open={bulkSourceData.sourcingTip}
          onClose={() => setBulkSourceData((prevValue)=>({
            ...prevValue,
            sourcingTip:false,
            isBluk:true
          }))}
          title={intl.get("Sourcing Request Sent")}
          secondaryActions={[
            {
              content: intl.get("Got it"),
              onAction: () =>  setBulkSourceData((prevValue)=>({
                ...prevValue,
                sourcingTip:false,
                isBluk:true
              })),
            },
          ]}
        >
          <Modal.Section>
            {`The sourcing request for ${bulkSourceData.isBluk ? "these orders" : "this order"}  has already been initiated, no need to send ${bulkSourceData.isBluk ? "" : "it"} again.`}
          </Modal.Section>
        </Modal>
      </div>
    );
  }
);

export default ArchiveOrderModal;
